<template>
  <ag-card-container
    :search.sync="search"
    :title="$t('company.title.companyList')"
    fluid
  >
    <company-list
      :value="companyList"
      :selected.sync="selectedCompanyIdList"
      :loading="loadingData"
      :search="search"
    >
      <template #footer>
        <v-btn
          color="accent"
          small
          append
          to="restore"
          v-text="$t('company.menu.restoreCompanyButton')"
        />
      </template>
    </company-list>

    <ag-float-button-container>
      <ag-confirm-dialog
        v-if="selectedCompanyIdList.length"
        :title="$t('general.confirmation')"
        :message="removeMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.remove')"
        validation-btn-color="error"
        @confirm="removeSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRemove"
            color="error"
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-delete</v-icon>
            <v-chip
              x-small
              class="px-1 float-chip font-weight-black"
              color="white"
              text-color="error"
              v-text="selectedCompanyIdList.length"
            />
          </v-btn>
        </template>
      </ag-confirm-dialog>

      <v-btn
        to="/companies/create"
        color="accent"
        fab
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </ag-float-button-container>

    <!-- RouterView for modals -->
    <router-view />
  </ag-card-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgCardContainer from 'src/components/common/AgCardContainer'
import AgFloatButtonContainer from 'src/components/common/AgFloatButtonContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import CompanyList from '../components/CompanyList'

export default {
  name: 'CompanyListContainer',
  components: {
    AgCardContainer,
    AgFloatButtonContainer,
    AgConfirmDialog,
    CompanyList,
  },
  data: () => ({
    companyList: [],
    selectedCompanyIdList: [],
    search: '',
    loadingData: false,
    loadingRemove: false,
  }),
  computed: {
    removeMessage () {
      const count = this.selectedCompanyIdList.length
      return this.$tc('company.remove.confirm', count, { count })
    },
    selectedCompanyList () {
      return this.selectedCompanyIdList.map(id => this.companyList.find(item => item.id === id))
    },
    hasMasterCompanyInSelection () {
      return this.selectedCompanyList.some(item => item.isMaster)
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'CompanyList') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      this.companyList = await Repositories.company.getList()
      this.loadingData = false
    },
    async removeSelected () {
      if (this.hasMasterCompanyInSelection) {
        const notification = this.$t('company.remove.cantRemoveMaster')
        this.showErrorNotification(notification)
      }
      else {
        try {
          this.loadingRemove = true
          const count = this.selectedCompanyIdList.length
          await Repositories.company.delete(this.selectedCompanyIdList)
          const notification = this.$tc('company.remove.success', count, { count })
          this.showSuccessNotification(notification)
        }
        catch (error) {
          const notification = Repositories.parseErrorMessage(error)
          this.showErrorNotification(notification)
        }
        finally {
          this.loadingRemove = false
          this.selectedCompanyIdList = []
          this.fetchData()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
